<template>
  <base-nav container-classes="container-fluid" class="navbar-top navbar-expand"
    :class="{ 'navbar-dark': type === 'default' }">
    <a href="#" aria-current="page"
      class="h4 mb-0 text-black text-uppercase d-none d-lg-inline-block active router-link-active"> </a>
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <b-form class="navbar-search form-inline mr-sm-3"
        :class="{ 'navbar-search-dark': type === 'default', 'navbar-search-dark': type === 'light' }"
        id="navbar-search-main">
        <!-- <b-form-group class="mb-0">
          <b-input-group class="input-group-alternative input-group-merge">
            <b-form-input placeholder="Buscar" type="text"> </b-form-input>

            <div class="input-group-append">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
          </b-input-group>
        </b-form-group> -->
        <HealthProcesosCoreAlert/>
        <LanguageSelector/>
      </b-form>
      <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="/img/theme/user.png">
            </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold" style="color:#fff">{{ userName }}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>

          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">{{ $t('menu') }}</h6>
          </b-dropdown-header><b-dropdown-item :href="`/perfil`">
            <i class="ni ni-single-02"></i>
            <span>{{ $t('perfil') }}</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="logout()">
            <i class="ni ni-user-run"></i>
            <span>{{ $t('cerrar_sesion') }}</span>
          </b-dropdown-item>

        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import utilsService from '@/api/utilsService';
import LanguageSelector from '@/components/LanguageSelector';
import HealthProcesosCoreAlert from '@/components/HealthProcesosCoreAlert';

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    LanguageSelector,
    HealthProcesosCoreAlert
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    userName() {
      const name = localStorage.getItem('user-name');
      return this.capitalizeFirstLetter(name);
    },
    user() {
      const user = utilsService.getUserInfo();
      return user;
    },
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    logout() {
      utilsService.logout();
    }
  }
};
</script>
